import axios from "axios";
import axiosInstance from "@/lib/axios";
import { useApiMutation } from "./useApiMutation";
import { ImageFileOrUrl } from "@/components/inputs/image-input";

export interface UpgradeDialogPayload {
  documentVal: string;
  user_id: string;
  tier: string;
  documentType: string;
  kycImage?: ImageFileOrUrl;
}

export class KycUpgradeError extends Error {
  source?: string;
  validationMessage?: string;

  constructor(message: string, source?: string, validationMessage?: string) {
    super(message);
    this.name = "KycUpgradeError";
    this.source = source;
    this.validationMessage = validationMessage;
  }
}

export const useUpgradeKYC = () => {
  return useApiMutation(
    async (payload: UpgradeDialogPayload) => {
      const form = new FormData();
      form.append("documentVal", payload.documentVal);
      form.append("user_id", payload.user_id);
      form.append("tier", payload.tier);
      form.append("documentType", payload.documentType);
      if (payload.kycImage && payload.kycImage.type === "file") {
        form.append("kycImage", payload.kycImage.file);
      }

      try {
        const response = await axiosInstance.post(
          `/wallet/kyc/user/upgrade`,
          form,
          { baseURL: "/api/proxy" },
        );
        return response.data;
      } catch (err) {
        if (axios.isAxiosError(err)) {
          const body = err.response?.data;
          throw new KycUpgradeError(
            body?.error || "KYC upgrade failed",
            body?.meta?.source,
            body?.meta?.validation_message,
          );
        }
        throw err;
      }
    },
    {
      meta: {
        loadingMessage: "Upgrading KYC...",
        errorMessage: "Failed to Upgrade KYC",
        invalidateQueries: (_, variables) => [
          ["user", "kyc", variables.user_id],
        ],
        successMessage: "KYC Upgraded successfully",
      },
    },
  );
};